import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import '../components.scss';
import { Button, Form, FormControl } from 'react-bootstrap';
import TextareaAutosize from 'react-autosize-textarea';
import { Multiselect } from 'multiselect-react-dropdown';
import { getLeadByID, setNewDataLead } from '../../redux/reduxActions/leadActions';
import {
  setLeadData, setObjectiveSelector, setSelectors, validateRequiredFields,
} from '../utils';


const EditLead = (props) => {
  const [subject, setSubject] = useState('');
  const [funnelTypeState, setFunnelType] = useState('');
  const [funnelStatus, setFunnelStatus] = useState('');
  const [priority, setPriority] = useState(4);
  const [responsibleState, setResponsible] = useState('');
  const [workTypeState, setWorkType] = useState('');
  const [workTechState, setWorkTech] = useState('');
  const [comment, setComment] = useState('');
  const [redmineLink, setRedmineLink] = useState('');
  const [estimationFile, setEstimationFile] = useState('');
  const [projectFolder, setProjectFolder] = useState('');
  const {
    priorities,
    funnelStatuses,
    funnelType,
    workType,
    workTech,
    responsible,
    selectedLead: { work_technology, work_type },
    selectedLead,
  } = props;
  // console.log(selectedLead);
  useEffect(() => { props.getLeadByID(props.match.params.id); }, []);
  useEffect(() => {
  	setFunnelType(selectedLead.funnel_type);
	  setFunnelStatus(selectedLead.funnel_status);
	  setPriority(selectedLead.priority);
	  setResponsible(selectedLead.responsible);
	  // setWorkType(selectedLead.work_type || []);
	  // setWorkTech(selectedLead.work_technology || []);
	  setProjectFolder(selectedLead.project_folder);
	  setRedmineLink(selectedLead.redmine_link);
	  setEstimationFile(selectedLead.estimation_file);
	  setComment(selectedLead.comment);
	  setSubject(selectedLead.title);
  }, [props]);
  const addLead = () => {
	  validateRequiredFields(funnelTypeState, funnelStatus, priority, responsibleState);
    if (!funnelTypeState || !funnelStatus || !priority || !responsibleState) {
      return;
    }
	  const workTypeData = workTypeState ? workTypeState.map((item) => item.id)
		  : work_type;
	  const workTechData = workTechState ? workTechState.map((item) => item.id)
		  : work_technology;
	  props.setNewDataLead(
    	props.match.params.id,
	    setLeadData(
		    subject,
		    funnelTypeState,
		    funnelStatus,
		    priority,
		    responsibleState,
		    workTypeData,
		    workTechData,
		    comment,
		    redmineLink,
		    projectFolder,
		    estimationFile,
	    ),
		  props.history.push,
		  false,
	    );
  };

  function setWorkTechSelected() {
	  if (work_technology && workTech.length) {
		  return work_technology.map((item) => workTech.find((inner) => inner.id === item));
	  }
	  return [];
  }

  function setWorkTypeSelected() {
	  if (work_type && workType.length) {
		  return work_type.map((item) => workType.find((inner) => inner.id === item));
	  }
	  return [];
  }
  return (
    <div>
      <div className="lead__container">
        <h3 style={{ color: '#383838', marginBottom: 10 }}>Edit Lead</h3>
        <div className="lead__container__inner" style={{ marginBottom: '1rem' }}>
          <p className="lead__title">
						Subject
          </p>
          <TextareaAutosize
            maxLength={101}
            onChange={(e) => setSubject(e.target.value)}
            className="lead__textarea lead__input"
            rows={1}
            placeholder="..."
            defaultValue={selectedLead.title}
          />
        </div>
        <div className="lead__container__inner">
          <p className="lead__title">
						Funnel Type
            <span style={{ color: 'red' }}>*</span>
          </p>
          <Form.Group style={{ width: '50%' }} controlId="formGridState">
            <FormControl
              value={funnelTypeState || ''}
              as="select"
              onChange={({ target: { value } }) => {
	              setFunnelType(value);
              }}
            >
              <option key="" value="">none</option>
              {setSelectors(funnelType)}
            </FormControl>
          </Form.Group>
        </div>
        <div className="lead__container__inner">
          <p className="lead__title">
						Funnel Status
            <span style={{ color: 'red' }}>*</span>
          </p>
          <Form.Group style={{ width: '50%' }} controlId="formGridState">
            <Form.Control
              as="select"
              value={funnelStatus || ''}
              onChange={({ target }) => setFunnelStatus(target.value)}
            >
              <option key="" value="">none</option>
              {setSelectors(funnelStatuses)}
            </Form.Control>
          </Form.Group>
        </div>
        <div className="lead__container__inner">
          <p className="lead__title">
						Priority
            <span style={{ color: 'red' }}>*</span>
          </p>
          <Form.Group style={{ width: '50%' }} controlId="formGridState">
            <Form.Control
              as="select"
              value={priority || ''}
              onChange={({ target }) => setPriority(target.value)}
            >
              <option key="" value="">none</option>
              {setObjectiveSelector(priorities)}
            </Form.Control>
          </Form.Group>
        </div>
        <div className="lead__container__inner">
          <p className="lead__title">
						Responsible
            <span style={{ color: 'red' }}>*</span>
          </p>
          <Form.Group style={{ width: '50%' }} controlId="formGridState">
            <Form.Control
              value={responsibleState || ''}
              as="select"
              onChange={({ target }) => setResponsible(target.value)}
            >
              <option key="" value="">none</option>
              {setObjectiveSelector(responsible)}
            </Form.Control>
          </Form.Group>
        </div>
        <div className="lead__container__inner" style={{ marginBottom: 16 }}>
          <p className="lead__title">
						Work Type
          </p>
          <div
            style={{ width: '50%' }}
          >
            <Multiselect
              options={workType}
              selectedValues={setWorkTypeSelected()}
              onSelect={(event) => {
				        setWorkType(event);
			        }}
              onRemove={(event) => {
	              setWorkType(event);
              }}
              displayValue="name"
            />
          </div>
        </div>
        <div className="lead__container__inner" style={{ marginBottom: 16 }}>
          <p className="lead__title">
						Work Tech
          </p>
          <div
            style={{ width: '50%' }}
          >
            <Multiselect
              options={workTech}
              selectedValues={setWorkTechSelected()}
              onSelect={(event) => {
	              setWorkTech(event);
			        }}
              onRemove={(event) => {
	              setWorkTech(event);
              }}
              displayValue="name"
            />
          </div>
        </div>
        <div className="lead__container__inner" style={{ marginBottom: 16 }}>
          <p className="lead__title">Description</p>
          <TextareaAutosize
            className="lead__textarea"
            style={{ width: '80%', padding: 10 }}
            rows={3}
            placeholder="..."
            defaultValue={selectedLead.comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </div>
        <div className="lead__container__inner" style={{ marginBottom: 16 }}>
          <p className="lead__title">
		        Redmine Link
          </p>
          <TextareaAutosize
            onChange={(e) => setRedmineLink(e.target.value)}
            className="lead__textarea lead__input"
            rows={1}
            style={{ width: '80%', padding: 10 }}
            placeholder="..."
            defaultValue={selectedLead.redmine_link}
          />
        </div>
        <div className="lead__container__inner" style={{ marginBottom: 16 }}>
          <p className="lead__title">
	          Estimation File Link
          </p>
          <TextareaAutosize
            onChange={(e) => setEstimationFile(e.target.value)}
            className="lead__textarea lead__input"
            rows={1}
            style={{ width: '80%', padding: 10 }}
            placeholder="..."
            defaultValue={selectedLead.estimation_file}
          />
        </div>
        <div className="lead__container__inner">
          <p className="lead__title">
	          Project Folder Link
          </p>
          <TextareaAutosize
            onChange={(e) => setProjectFolder(e.target.value)}
            className="lead__textarea lead__input"
            rows={1}
            style={{ width: '80%', padding: 10 }}
            placeholder="..."
            defaultValue={selectedLead.project_folder}
          />
        </div>
        <Button
          onClick={() => addLead()}
          variant="primary"
          style={{ marginLeft: '88%', marginTop: 20 }}
          className="main-button-filled"
        >
					Save
        </Button>
      </div>
    </div>
  );
};
export default connect((state) => ({
  priorities: state.skillsReducer.priorities,
  funnelStatuses: state.leadReducer.funnelStatuses,
  funnelType: state.leadReducer.funnelType,
  workType: state.leadReducer.workType,
  workTech: state.leadReducer.workTech,
  responsible: state.leadReducer.responsible,
  selectedLead: state.leadReducer.selectedLead,
}), { setNewDataLead, getLeadByID })(EditLead);
